import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { toast } from 'sonner';
import { Button } from '../components/ui/button';
import { Input } from '../components/ui/input';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Lock } from 'lucide-react';

const AdminLogin = () => {
  const navigate = useNavigate();
  const [credentials, setCredentials] = useState({
    username: '',
    password: ''
  });
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setCredentials(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    // Get credentials from environment variables (required)
    const ADMIN_USERNAME = process.env.REACT_APP_ADMIN_USERNAME;
    const ADMIN_PASSWORD = process.env.REACT_APP_ADMIN_PASSWORD;
    
    // Validate credentials are set
    if (!ADMIN_USERNAME || !ADMIN_PASSWORD) {
      toast.error('Admin credentials not configured. Please contact support.');
      setLoading(false);
      return;
    }

    if (credentials.username === ADMIN_USERNAME && credentials.password === ADMIN_PASSWORD) {
      // Set authentication token
      localStorage.setItem('adminAuthenticated', 'true');
      localStorage.setItem('adminLoginTime', Date.now().toString());
      toast.success('Login successful!');
      navigate('/admin');
    } else {
      toast.error('Invalid username or password');
    }

    setLoading(false);
  };

  return (
    <div className="admin-login">
      <div className="login-container">
        <Card className="login-card">
          <CardHeader>
            <div className="login-header">
              <Lock className="lock-icon" size={48} />
              <CardTitle className="login-title">Admin Login</CardTitle>
              <p className="login-subtitle">Electrum Prosperity Group</p>
            </div>
          </CardHeader>
          <CardContent>
            <form onSubmit={handleSubmit} className="login-form">
              <div className="form-field">
                <label htmlFor="username">Username</label>
                <Input
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Enter username"
                  value={credentials.username}
                  onChange={handleInputChange}
                  required
                  className="login-input"
                  autoComplete="username"
                />
              </div>
              <div className="form-field">
                <label htmlFor="password">Password</label>
                <Input
                  type="password"
                  id="password"
                  name="password"
                  placeholder="Enter password"
                  value={credentials.password}
                  onChange={handleInputChange}
                  required
                  className="login-input"
                  autoComplete="current-password"
                />
              </div>
              <Button type="submit" disabled={loading} className="login-btn">
                {loading ? 'Logging in...' : 'Login'}
              </Button>
            </form>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default AdminLogin;
